import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-collapsible';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import * as styles from './style';
import ProductList from '../ProductList';
import Header from '../Header';
import { ENTITIES, PRODUCT_STATUS } from '../../../../helpers/constants';
import withProducts from '../../../../containers/Products';
import equals from '../../../../helpers/equals';
import { getDraggableStyle } from '../../style';
import { isAnyProductActive } from '../../../../helpers/products';

class CategoryItem extends Component {
  handleCallbackStatus = (type, id) => {
    const { category, changeStatus } = this.props;

    changeStatus(type, id, category.id);
  };

  handleCollapse = () => {
    const { category, collapseCategory } = this.props;

    collapseCategory(category.id);
  };

  shouldComponentUpdate(nextProps) {
    if (!equals(this.props, nextProps)) {
      return true;
    }

    return false;
  }

  render() {
    const {
      index,
      category,
      toggleListCategoryItem,
      toggleListProductItem,
      productAction,
      onClickProductActions,
      isDragDisabled,
      isProductDragDisabled,
      updateProductCategoryName,
      editProduct,
      categories,
    } = this.props;
    const { id, name, checked, isOpen, products } = category;

    const draggableId = `${ENTITIES.CATEGORY}_${id}`;

    return (
      <Draggable draggableId={draggableId} index={index} isDragDisabled={!!isDragDisabled}>
        {(provided, snapshot) => (
          <styles.Content
            id={`category_collapsible_${name}_${id}`}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            isDragging={snapshot.isDragging}
            style={getDraggableStyle(provided.draggableProps.style, snapshot)}
          >
            <Collapsible
              trigger={
                <Header
                  id={id}
                  name={name}
                  check={checked}
                  isOpen={isOpen}
                  toggleListCategoryItem={toggleListCategoryItem}
                  numberOfProducts={products.length}
                  isDragDisabled={isDragDisabled}
                  isDragging={snapshot.isDragging}
                  onClickProductActions={onClickProductActions}
                  updateProductCategoryName={updateProductCategoryName}
                  isCheckDisabled={!isAnyProductActive(products)}
                />
              }
              open={isOpen}
              handleTriggerClick={products.length ? this.handleCollapse : null}
              overflowWhenOpen="visible"
            >
              {products.length ? (
                <Droppable droppableId={`products_${id}`} type={`product-${id}`}>
                  {provided => (
                    <div ref={provided.innerRef} {...provided.droppableProps}>
                      <ProductList
                        id={id}
                        products={products}
                        categories={categories}
                        handleCallbackStatus={this.handleCallbackStatus}
                        toggleListProductItem={toggleListProductItem}
                        productAction={productAction}
                        onClickProductActions={onClickProductActions}
                        editProduct={editProduct}
                        isProductDragDisabled={isProductDragDisabled}
                      />
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              ) : null}
            </Collapsible>

            {provided.placeholder}
          </styles.Content>
        )}
      </Draggable>
    );
  }
}

CategoryItem.propTypes = {
  changeStatus: PropTypes.func,
  index: PropTypes.number.isRequired,
};

export default withProducts(CategoryItem);



// WEBPACK FOOTER //
// ./src/screens/Product/Categories/CategoryItem/index.js